export default {"src":"/_next/static/media/servicesBanner.1b898e3a.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};